import { firstValueFrom, lastValueFrom } from 'rxjs';
import { UserService } from '../../../services/user.service';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MaterialModule } from '../../../material.module';
import { LabelChipComponent } from '../../label-chip/label-chip.component';
import { Account } from '../../../models/account.model';
import { CommonModule } from '@angular/common';
import { WithdrawalService } from '../../../services/withdrawal.service';
import { blankOpen, formatDate, formatDecimalTrim, getAdToYm, getNextAd, getPool, getPrevAd, rateToPercent, toNum } from '../../../misc/functions';
import { RouterModule } from '@angular/router';
import { Inquiry } from '../../../models/inquiry.model';
import { InquiryService } from '../../../services/inquiry.service';
import { MonthlyReportService } from '../../../services/monthly-report.service';
import { MonthlyReport } from '../../../models/monthly-report.model';
import { ModalSnackbarService } from '../../../services/modal-snackbar.service';
import { WithdrawalTransactionService } from '../../../services/withdrawal-transaction.service';
import { WithdrawalTransaction } from '../../../models/withdrawal-transaction.model';
import { AdminUsersService } from '../../../services/admin-users.service';

@Component({
  selector: 'app-user-info',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    LabelChipComponent
],
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit, AfterViewInit {

  @Input() id: number|undefined|null = 0;
  @Input() title: string|undefined|null = '';
  @Input() name: string|undefined|null;
  @Input() login: string|undefined|null;
  @Input() email: string|undefined|null;
  @Input() status: string|undefined|null = '';
  @Input() priority: string|undefined|null = '';
  @Input() user_id: number = 0;
  @Input() cap_id: string|undefined|null = undefined;
  @Input() isExpanded = false;
  @Input() abh_key: string|undefined|null;
  @Input() isEnableEmailUpdate = false;

  @Output() accountsFilled = new EventEmitter<Account[]>();

  accounts?: Account[] = undefined;

  inquiries?: Inquiry[] = undefined;
  withdrawals?: Inquiry[] = undefined;
  transfers?: Inquiry[] = undefined;
  invests?: Inquiry[] = undefined;
  transactions?: WithdrawalTransaction[] = undefined;

  formatDate = formatDate;
  blankOpen = blankOpen;
  getPool = getPool;
  rateToPercent = rateToPercent;
  formatDecimalTrim = formatDecimalTrim;
  getAdToYm = getAdToYm;

  isLoaded = false;

  currentAd: number = 0;
  prevAd?: number = undefined;
  nextAd?: number = undefined;

  reports: MonthlyReport[]|undefined = undefined;

  isEmailUpdate = false;

  constructor(
    private userService: UserService,
    public adminUsersService: AdminUsersService,
    private inquiryService: InquiryService,
    private monthlyService: MonthlyReportService,
    private withdrawalTransactionservice: WithdrawalTransactionService,
    private snackBar: ModalSnackbarService,
  ) {}

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.asyncInit();
    }, 50);
  }

  async asyncInit() {
    if (this.user_id > 0) {

      this.currentAd = await firstValueFrom(this.monthlyService.getLatestAd(true));
      this.changeAd(this.currentAd);


      [this.inquiries, this.withdrawals, this.transfers, this.invests, this.transactions] = await Promise.all([
        lastValueFrom(this.inquiryService.getAllByUserId('お問い合わせ', this.user_id, true)),
        lastValueFrom(this.inquiryService.getAllByUserId('出金依頼', this.user_id, true)),
        lastValueFrom(this.inquiryService.getAllByUserId('振替依頼', this.user_id, true)),
        lastValueFrom(this.inquiryService.getAllByUserId('新規出資依頼', this.user_id, true)),
        lastValueFrom(this.withdrawalTransactionservice.getAllByUserId(this.user_id))
      ]);

      this.isLoaded = true;
    }
  }

  openTransaction(obj: WithdrawalTransaction) {
    blankOpen(undefined, '/client/admin/withdrawalTransaction/' + obj.id);
  }

  open(obj: Inquiry) {
    blankOpen(undefined, '/client/admin/inquiry/' + obj.id);
  }

  transactionAlt(obj: WithdrawalTransaction) {
    // 頭４行を取り出して「:」以降を結合する
    const heads = obj.alt_body.split('\n').slice(0, 4);
    const lines = heads.map(x => x.split(/[:：]/).pop()?.trim());
    return lines.join('・');
  }

  transferTitle(obj: MonthlyReport) {
    return `${obj.transfer_pool} (${this.rateToPercent(obj.transfer_hdc)} %)\n${obj.transfer_note}`;
  }

  changeAd(ad: number) {

    if (!this.abh_key) return;

    this.currentAd = ad;
    this.prevAd = getPrevAd(ad);
    this.nextAd = getNextAd(ad);

    this.monthlyService.getByLoginIdAndAd(this.abh_key, ad, true).subscribe({
      next: (res) => {
        if (res) {
          this.reports = res;
        }
      },
      error: () => this.snackBar.show(`月報の読み込みに失敗しました`)
    });
  }

  updateEmail(id: number|undefined|null, email: string) {
    console.log(id, email);
    if (!id || !email) return;

    this.adminUsersService.updateEmail(id, email).subscribe({
      next: (res) => {
        if (res) {
          console.log(res);

          this.isEmailUpdate = false;
          this.email = undefined;
          this.title = undefined;

          setTimeout(() => {
            alert("再検索して更新結果を確認して下さい");
          }, 400);

        }
      },
      error: () => this.snackBar.show(`Email の更新に失敗しました`)
    });


  }

}

